export const DASHBOARD_VIEW_STORAGE_KEY = 't7x.dashboardViewMode';

export const DASHBOARD_VIEW = {
  pro: 'pro',
  basic: 'basic'
};
